import { PairsV4 } from '@ui/services/contract/hooks/PairsManagerFacet/usePairsV4';
import { MarketInfo } from '@ui/services/contract/hooks/TradingReaderFacet/useGetMarketInfos/query';

export const getDisplayFundingFeeRate = ({
  basicFundingRatePerSecond,
  longHoldingFeeRatePerSecond,
  shortHoldingFeeRatePerSecond,
}: {
  basicFundingRatePerSecond: MarketInfo['fundingFeeRate'] | undefined;
  longHoldingFeeRatePerSecond: PairsV4['longHoldingFeeRate'] | undefined;
  shortHoldingFeeRatePerSecond: PairsV4['shortHoldingFeeRate'] | undefined;
}) => {
  if (
    !basicFundingRatePerSecond ||
    !longHoldingFeeRatePerSecond ||
    !shortHoldingFeeRatePerSecond
  )
    return undefined;

  return {
    displayLongFundingFeeRatePerSecond: basicFundingRatePerSecond
      .times(-1)
      .minus(longHoldingFeeRatePerSecond),
    displayShortFundingFeeRatePerSecond: basicFundingRatePerSecond.minus(
      shortHoldingFeeRatePerSecond,
    ),
  };
};
